import CatalogObjectSerializer from '@square/dashboard-items-data/serializers/connect/catalog-object';
export default CatalogObjectSerializer.extend({
  attrs: {
    subscriptionPlan: {
      serialize: 'ids',
      deserialize: 'ids',
      serializedOnFragment: 'subscription_plan_data',
      serializedOnKey: 'subscription_plan_id'
    }
  }
});